import { useEffect, useRef } from 'react';
import { trackAnalysisViewed, type AnalysisType } from './analysis-instrumentation';

/** Dispara web_analysis_viewed uma vez por mount quando os dados carregam. */
export function useAnalysisViewTracking(
  analysisType: AnalysisType,
  isSuccess: boolean,
  source = 'page_load',
): void {
  const tracked = useRef(false);

  useEffect(() => {
    if (isSuccess && !tracked.current) {
      tracked.current = true;
      trackAnalysisViewed(analysisType, source);
    }
  }, [analysisType, isSuccess, source]);
}
